import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { EmailService } from '@tsin-core/services/http/email.service';
import { ApplicationService } from '@tsin-core/services/http/application.service';
import { CleanupTestCandidates, DisableAllEmails, EnableAllEmails, GenerateTestCandidates, GetEmailStatus, GetSettings, ToggleAllEmails } from './settings.actions';
import { tap } from 'rxjs';

export class SettingsStateModel {
  public emailSettings: { disabled: boolean, effective: boolean } | null = null;
  public lastTestDataResult: any = null;
}

const defaults = {
  emailSettings: null,
  lastTestDataResult: null
};

@State<SettingsStateModel>({
  name: 'settingsState',
  defaults
})
@Injectable()
export class SettingsState {

  emailService = inject(EmailService);
  applicationService = inject(ApplicationService);

  @Selector()
  static getEmailSettings(state: SettingsStateModel) {
    return state.emailSettings;
  }

  @Action(GetSettings)
  getSettings(ctx: StateContext<SettingsStateModel>) {
    return this.emailService.getSettings().subscribe((result) => {
      const state = ctx.getState();
      ctx.setState({
        ...state,
        emailSettings: result
      });
    });
  }

  @Action(ToggleAllEmails)
  toggleAllEmails(ctx: StateContext<SettingsStateModel>) {
    return this.emailService.toggleAllEmails().subscribe((result) => {
      const state = ctx.getState();
      ctx.setState({
        ...state,
        emailSettings: result
      });
    });
  }

  @Action(EnableAllEmails)
  enableAllEmails(ctx: StateContext<SettingsStateModel>) {
    return this.emailService.enableAllEmails().subscribe((result) => {
      const state = ctx.getState();
      ctx.setState({
        ...state,
        emailSettings: result
      });
    });
  }

  @Action(DisableAllEmails)
  disableAllEmails(ctx: StateContext<SettingsStateModel>) {
    return this.emailService.disableAllEmails().subscribe((result) => {
      const state = ctx.getState();
      ctx.setState({
        ...state,
        emailSettings: result
      });
    });
  }

  @Action(GetEmailStatus)
  getEmailStatus(ctx: StateContext<SettingsStateModel>) {
    return this.emailService.getEmailStatus().subscribe((result) => {
      const state = ctx.getState();
      ctx.setState({
        ...state,
        emailSettings: result
      });
    });
  }

  @Action(GenerateTestCandidates)
  generateTestCandidates(_ctx: StateContext<SettingsStateModel>, action: GenerateTestCandidates) {
    return this.applicationService.generateTestCandidates(action.phase, action.examId).pipe(
      tap((res) => {
        _ctx.patchState({ lastTestDataResult: res?.data ?? null });
      })
    );
  }

  @Action(CleanupTestCandidates)
  cleanupTestCandidates(_ctx: StateContext<SettingsStateModel>) {
    return this.applicationService.cleanupTestCandidates();
  }


}


//  // GET: Get email settings
//   getSettings(): Observable<any> {
//     return this.http.get<any>(`${environment.apiUrl2}/api/settings`);
//   }

//   // POST: Disable all emails
//   disableAllEmails(): Observable<any> {
//     return this.http.post<any>(`${environment.apiUrl2}/api/settings/disable-all-emails`, {});
//   }

//   // POST: Enable all emails
//   enableAllEmails(): Observable<any> {
//     return this.http.post<any>(`${environment.apiUrl2}/api/settings/enable-all-emails`, {});
//   }

//   // POST: Toggle all emails
//   toggleAllEmails(): Observable<any> {
//     return this.http.post<any>(`${environment.apiUrl2}/api/settings/toggle-all-emails`, {});
//   }

//   // GET: Get email status
//   getEmailStatus(): Observable<any> {
//     return this.http.get<any>(`${environment.apiUrl2}/api/settings/email-status`);
//   }

// export class SettingsAction {
//   static readonly type = '[Settings] Add item';
//   constructor(public payload: string) { }
// }

// export class getSettings {
//   static readonly type = '[Settings] Get Settings'
// }

// export class toggleAllEmails {
//   static readonly type = '[Settings] Toggle All Emails'
// }

// export class enableAllEmails {
//   static readonly type = '[Settings] Enable All Emails'
// }

// export class disableAllEmails {
//   static readonly type = '[Settings] Disable All Emails'
// }

// export class getEmailStatus {
//   static readonly type = '[Settings] Get Email Status'
// }
